<div class="text-[var(--faculty-600,platform-600)] relative mb-4 sm:mb-10">
  <div class="overflow-hidden rounded-full">
    <div
      class="h-2 rounded-full transition-[width,color] duration-300 ease-in-out bg-[var(--faculty-500)]"
      [style.width.%]="isError() ? 100 : currentProgress()"
    ></div>
  </div>

  <div
    class="mt-3 hidden text-sm font-medium relative"
    [ngClass]="{ 'sm:flex': !isError() }"
  >
    @for (step of steps(); track step; let i = $index) {
      <div
        [style.left.%]="(i / (steps().length - 1)) * 100"
        [class.active]="currentProgress() >= (i / (steps().length - 1)) * 100"
        class="step"
      >
        {{ step }}
      </div>
    }
  </div>
</div>
